import {
  SUBMIT_EDIT_PROFILE_ACTION_REQUESTED,
  SUBMIT_EDIT_PROFILE_ACTION_DISPATCHER,
  SUBMIT_EDIT_PROFILE_ERROR_DISPATCHER,
  SUBMIT_EMPTY_EDIT_PROFILE_STATE_ACTION,
  EDIT_PROFILE_LOADING,
} from "./Action";

const initialState = {
  successData: { message: "", apiData: {} },
  failureData: { message: "", apiData: {} },
  loading: false,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_EDIT_PROFILE_ACTION_REQUESTED:
      return { ...state, loading: true };
    case SUBMIT_EDIT_PROFILE_ACTION_DISPATCHER:
      if (action.payload.data) {
        return {
          ...state,
          successData: {
            message: action.payload.data.Message,
            apiData: action.payload.data,
          },
          loading: false,
        };
      } else {
        return { ...state, loading: false };
      }
    case SUBMIT_EDIT_PROFILE_ERROR_DISPATCHER:
      if (action.payload.data) {
        return {
          ...state,
          successData: {
            message: action.payload.data.Message,
            apiData: action.payload.data,
          },
          loading: false,
        };
      } else {
        return { ...state, loading: false };
      }
    case EDIT_PROFILE_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    case SUBMIT_EMPTY_EDIT_PROFILE_STATE_ACTION:
      return {
        ...state,
        successData: {
          message: "",
          apiData: {}
        },
        loading: false,
      };
    default:
      return state;
  }
};

export default reducer;
